import type { ReactNode } from 'react';

import { nameInitials } from '@iconik-io/core/src/name_initials';
import { getEntityById } from '@iconik-io/shared-lib/src/redux/entities/utils';
import { Avatar, type DropdownListOption, Text } from '@iconik-io/uad';

import { useAppSelector } from '../../store/react_redux_typed';

import styles from './user_filter_option.module.css';

export type FilterOptionProps = {
  thumbnail: ReactNode;
  label: string;
};

export function FilterOption({ thumbnail, label }: FilterOptionProps) {
  return (
    <span className={styles.filter_option}>
      {thumbnail}
      <Text
        variant="body"
        color="high_emphasis"
        className={styles.filter_option_label}
      >
        {label}
      </Text>
    </span>
  );
}

type UserFilterOptionProps = {
  option: DropdownListOption;
};

export function UserFilterOption({ option }: UserFilterOptionProps) {
  const user = useAppSelector((state) =>
    getEntityById(state, 'users_basic', String(option.id)),
  );
  return (
    <FilterOption
      thumbnail={
        <Avatar
          label={user ? nameInitials(user) : option.label}
          src={user?.photo_small ?? undefined}
          size="xs"
        />
      }
      label={option.label}
    />
  );
}
